export default __webpack_public_path__ + "media/images/Symbol_Delete-46c04e554894096b07fa50afaed31704.png";